import { BasketItem } from '@common/components/BasketItem';
import { Routes } from '@common/constants';
import BASKET_UPDATE_TYPES from '@routes/Basket/components/BasketUpdateTypes';
import React from 'react';
import { Discount, Personalization, Price } from 'shared-types/Common';
import { VoucherDetails } from './VoucherDetails';
import { VoucherMetadata, VoucherMetadataProps } from './VoucherMetadata';

export type Item = {
  type: 'vouchers';
  linkRoute?: string;
  /**
   * @deprecated Migrating to fulfilables service typings
   */
  voucher: any;
  /**
   * @deprecated Migrating to fulfilables service typings
   */
  option: any | null;
  id: number;
  quantity: number;
  price: Price;
  discount?: Discount;
  personalization: Personalization;
  deliveryDetails?: {
    packagingName: string;
  };
  voucherId?: number;
  expireAt?: string;
  detailsBag?: {
    discount: {
      fullPrice: string; // e.g. £85.00
      fullPriceAsInt: number; // e.g. 8500
      discountedPrice: string; // e.g. £63.75
      discountedPriceAsInt: number; // e.g. 6375
      name: string;
      type: 'Percentage' | 'Fixed';
      value: string; // e.g. '25', i.e. value of the discount reduction itself
    };
    images: string[];
    name: string;
    price: string;
    priceAsInt: number;
    terms: string;
  };
} & VoucherMetadataProps;

export type VoucherProps = {
  isEditable: boolean;
  item: Item;
  isQuantityPickerHidden: boolean;
  onChange: (
    type: BASKET_UPDATE_TYPES.QUANTITY | BASKET_UPDATE_TYPES.REMOVE,
    itemId: number | string,
    quantity?: number
  ) => void;
};

export const Voucher: React.FC<VoucherProps> = ({ isEditable = true, item, onChange }) => {
  const {
    linkRoute = Routes.VOUCHER_DETAIL,
    voucher,
    option,
    id,
    price,
    voucherOption,
    detailsBag,
  } = item;

  const linkParams = {
    id: voucher.id,
  };
  const name = `${voucher.name} ${option ? `- ${option.name}` : ''}`;

  function renderVoucherMetadata() {
    return <VoucherMetadata voucherOption={voucherOption} />;
  }

  function handleVoucherRemoval() {
    onChange(BASKET_UPDATE_TYPES.REMOVE, id);
  }

  return (
    <>
      <BasketItem
        key={id}
        linkParams={linkParams}
        linkRoute={linkRoute}
        name={name}
        price={
          detailsBag?.discount
            ? { amount: detailsBag.discount.fullPriceAsInt, currencyCode: price.currencyCode }
            : price
        }
        discount={
          detailsBag?.discount
            ? {
                discountedPrice: {
                  amount: detailsBag.discount.discountedPriceAsInt,
                  currencyCode: price.currencyCode,
                },
                standardPrice: price,
              }
            : undefined
        }
        thumbnail={voucher?.mainImageUrl}
        isEditable={isEditable}
        onRemove={handleVoucherRemoval}
        renderDetails={<VoucherDetails item={item} isEditable />}
        renderMetadata={renderVoucherMetadata}
        shouldRenderMobileDetails={true}
      />
    </>
  );
};
